const headers = [
  // { text: '', value: 'data-table-expand' },
  {
    text: 'Bet ID',
    align: 'start',
    value: 'id',
    class: 'raceColumnShow',
    sortable: true,
    filterable: true
  },
  {
    text: 'Client Ref',
    value: 'userId',
    class: 'raceColumnShow',
    sortable: true,
    filterable: true
  },
  {
    text: 'Medium',
    value: 'medium',
    class: 'raceColumnShow',
    sortable: false,
    filterable: true
  },
  {
    text: 'Product',
    value: 'infoType',
    class: 'raceColumnShow',
    sortable: false,
    filterable: true
  },
  {
    text: 'Time of Bet',
    value: 'time',
    class: 'raceColumnShow',
    sortable: true,
    filterable: true
  },
  {
    text: 'Race',
    value: 'raceNumber',
    class: 'raceColumnShow',
    sortable: false,
    filterable: true
  },
  {
    text: 'Venue',
    value: 'track',
    class: 'raceColumnShow',
    sortable: false,
    filterable: false
  },
  {
    text: 'Meeting Type',
    value: 'meetingType',
    class: 'raceColumnShow',
    sortable: false,
    filterable: false
  },
  // {
  //   text: 'Type',
  //   value: 'meeting_type',
  //   class: 'raceColumnShow',
  // },
  {
    text: 'Runner',
    value: 'runnerNumber',
    class: 'raceColumnShow',
    sortable: false,
    filterable: true
  },
  // {
  //   text: 'Name',
  //   value: 'runner_name',
  //   class: 'raceColumnShow',
  // },
  {
    text: 'Bet Type',
    value: 'type',
    class: 'raceColumnShow',
    sortable: false,
    filterable: true
  },
  {
    text: 'Source',
    value: 'source',
    align: 'center',
    class: 'raceColumnShow',
    sortable: false,
    filterable: true
  },
  {
    text: 'Amount ($)',
    align: 'end',
    value: 'amount',
    class: 'raceColumnShow',
    sortable: true,
    filterable: false
  },
  {
    text: 'Bonus Bet',
    value: 'bonus',
    class: 'raceColumnShow',
    sortable: false,
    filterable: false
  },
  {
    text: 'Price ($)',
    align: 'end',
    value: 'price',
    class: 'raceColumnShow',
    sortable: true,
    filterable: false
  },
  {
    text: 'Payout ($)',
    align: 'end',
    value: 'payout',
    class: 'raceColumnShow',
    sortable: true,
    filterable: false
  },
  {
    text: 'Net Result ($)',
    align: 'end',
    value: 'netResult',
    class: 'raceColumnShow',
    sortable: false,
    filterable: false
  }
]

// BetBacks Headers for Tables in Summary and Dashboard
const betbacksHeadersDash = [
  // {
  //   text: 'Bet ID',
  //   align: 'start',
  //   value: 'id',
  // },
  {
    text: 'Bet Medium',
    value: 'medium'
  },
  {
    text: 'Product',
    value: 'info_type'
  },
  {
    text: 'Time of Bet',
    value: 'time'
  },
  {
    text: 'Race',
    align: 'center',
    value: 'race_number',
    class: 'raceColumnShow'
  },
  {
    text: 'Venue',
    value: 'track'
  },
  {
    text: 'Runner No.',
    align: 'center',
    value: 'runner_number'
  },
  // {
  //   text: 'Name',
  //   value: 'runner_name',
  // },
  {
    text: 'Bet Type',
    value: 'type',
    class: 'raceColumnShow'
  },
  {
    text: 'Source',
    value: 'source',
    class: 'raceColumnShow'
  },
  {
    text: 'Amount ($)',
    align: 'end',
    value: 'amount'
  },
  {
    text: 'Price ($)',
    align: 'end',
    value: 'price'
  },
  {
    text: 'Payout ($)',
    align: 'end',
    value: 'payout'
  },
  {
    text: 'Net Result ($)',
    align: 'end',
    value: 'net_result'
  },
  {
    text: 'Bet Back Amount',
    value: 'bet_back_amount'
  },
  {
    text: 'Bet Back Revenue',
    value: 'bet_back_revenue '
  },
  {
    text: 'Bet Back Date',
    value: 'bet_back_date'
  },
  {
    text: 'Bet Back ID',
    value: 'bet_back_id'
  },
  {
    text: 'Bet Back Agency',
    value: 'bet_back_agency'
  }
]

const mediums = [
  {
    name: 'Internet',
    value: 'Internet'
  },
  {
    name: 'Phone',
    value: 'Phone'
  },
  {
    name: 'Cash',
    value: 'Cash'
  },
  {
    name: 'NativeApp',
    value: 'NativeApp'
  }
]

const infoTypes = [
  {
    name: 'Fixed Odds'
  },
  {
    name: 'Starting Price'
  },
  {
    name: 'Starting Price Guarantee'
  },
  {
    name: 'Odds Boost'
  },
  {
    name: 'Official Starting Price'
  },
  {
    name: 'Top Fluctuation'
  },
  {
    name: 'Goat Bump'
  },
  {
    name: 'Best Tote Price'
  },
  {
    name: 'Best of the Best'
  },
  {
    name: 'Middle Tote Price'
  },
  {
    name: 'S-TAB Price'
  },
  {
    name: 'SP'
  },
  {
    name: 'NSW Tote Price'
  },
  {
    name: 'Bookmaker Fixed SP'
  }
]

const betTypes = [
  {
    name: 'Win',
    value: 'win'
  },
  {
    name: 'Place',
    value: 'place'
  },
  {
    name: 'Multi',
    value: 'multi'
  },
  {
    name: 'Trifecta',
    value: 'trifecta'
  },
  {
    name: 'Exacta',
    value: 'exacta'
  },
  {
    name: 'Quinella',
    value: 'quinella'
  },
  {
    name: 'First Four',
    value: 'firstfour'
  },
  {
    name: 'Daily Double',
    value: 'dailydouble'
  },
  {
    name: 'Quaddie',
    value: 'quaddie'
  }
]

export default {
  headers,
  betbacksHeadersDash,
  mediums,
  infoTypes,
  betTypes
}
